import { render } from "./EscalaRow.vue?vue&type=template&id=0cf5eb35"
import script from "./EscalaRow.vue?vue&type=script&lang=js"
export * from "./EscalaRow.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__